export default __webpack_public_path__ + "static/404-2913b7141d53a7f7ed60ef34844d3341.png";